module.exports = __webpack_public_path__ + "img/step51_a_printer_basic_open_main_door_remove_pins.29df4c29.png";